import React, { useCallback } from 'react';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { useCardBoxContext } from './card-box.provider';
import { StyledHeading, SeeMoreIcon } from './card-box.styles';

export const CardBoxHeading: React.FC = ({ children }) => {
    const { opened, setOpened, allowCollapse } = useCardBoxContext();

    const toggle = useCallback(() => {
        setOpened(!opened);
    }, [opened, setOpened]);

    return (
        <StyledHeading opened={opened} alignItems='center'>
            {!allowCollapse && children}
            {allowCollapse && (
                <FlexBox alignItems='center' justifyContent='space-between'>
                    <div>{children}</div>
                    <SeeMoreIcon opened={opened} icon='chevronDown' variant='regular' onClick={toggle} />
                </FlexBox>
            )}
        </StyledHeading>
    );
};
